import React, { useEffect } from 'react';
import Modal from '@/ctComponents/Modal';
import Table from '@/ctComponents/Table';
import { Icons } from '@/assets';
import { ReactSVG } from 'react-svg';
import styles from './ContainerModals.module.css';
import CustomSelectEx from '@/ctComponents/CustomSelectEx';
import LicenseInput from './LicenseInput';
import SubmitButton from '@/ctComponents/submitButton';

// const LicenseInput = ({ value, onChange }) => (
//   <input
//     className={styles.licenseInput}
//     placeholder="Select"
//     value={value}
//     onChange={onChange}
//   />
// );
const TrashButton = ({ onClick }) => (
  <button className={styles.trashButton} onClick={onClick}>
    <ReactSVG src={Icons.trashIcon} />
  </button>
);

const columns = [
  { field: 'id', label: '#', width: '40px' },
  {
    field: 'container',
    label: (
      <span className={styles.tableHeaderCell}>
        Container<span className={styles.tableHeaderRequired}>*</span>
      </span>
    ),
    width: '120px',
  },
  {
    field: 'size',
    label: (
      <span className={styles.tableHeaderCell}>
        Size<span className={styles.tableHeaderRequired}>*</span>
      </span>
    ),
    width: '150px',
  },
  {
    field: 'ssl',
    label: (
      <span className={styles.tableHeaderCell}>
        SSL<span className={styles.tableHeaderRequired}>*</span>
      </span>
    ),
    width: '150px',
  },
  {
    field: 'license',
    label: <span className={styles.tableHeaderCell}>License Plate</span>,
    width: '120px',
  },
];
const EditContainerModalContent = ({
  containerData,
  options,
  selectedContainer,
  loadingSubmit,
  handleSubmit,
  edittedRow,
  setEdittedRow,
}) => {
  console.log('edittedRow', containerData);
  useEffect(() => {
    setEdittedRow({
      id: 1,
      book_id: containerData.id || '',
      container: containerData.number || '',
      container_id: containerData.container_id || null,
      size: containerData.size || '',
      specification_id:
        options[0].options.find((opt) => opt.label === containerData?.size)
          ?.value || null,
      ssl: containerData.ssl || '',
      ssl_id:
        options[1].options.find((opt) => opt.label === containerData?.ssl)
          ?.value || null,
      license: containerData.license || '',
    });
  }, []);

  return (
    <div className="w-full overflow-x-hidden">
      <div className={styles.editModalDescription}>
        Update container number, size, line, or license plate.
      </div>
      <div className="overflow-x-auto">
        <Table
          minWidth={'fit-content'}
          // wrapperRef={wrapperRef}
          componentName={'EditAutobookContainer'}
          stickyHeader={true}
          maxHeight={'250px'}
          columns={columns}
          data={[
            {
              ...edittedRow,
              container: (
                <span>{containerData?.number}</span>
                // <CustomSelectEx
                //   placeholder="Container Name"
                //   value={row.container}
                //   onChange={(e) =>
                //     setRow({ ...row, container: e.target.value })
                //   }
                //   options={options.containers}
                //   dropdown={true}
                //   height={'25px'}
                // />
              ),
              size: !containerData?.is_liveOnLoad ? (
                <span>{containerData.size}</span>
              ) : (
                <CustomSelectEx
                  placeholder="Select Size"
                  value={
                    options[0].options.find(
                      (opt) => opt.label === edittedRow?.size
                    ) || null
                  }
                  onChange={(item) =>
                    setEdittedRow({
                      ...edittedRow,
                      size: item.label,
                      specification_id: item.value,
                    })
                  }
                  options={options[0].options || []}
                  dropdown={true}
                  height={'35px'}
                  mini={true}
                />
              ),
              ssl: !containerData?.is_liveOnLoad ? (
                <span>{containerData.ssl}</span>
              ) : (
                (console.log('options', options[1].options),
                (
                  <CustomSelectEx
                    placeholder="Select SSL"
                    value={
                      options[1].options.find(
                        (opt) => opt.label === edittedRow?.ssl
                      ) || null
                    }
                    onChange={(item) =>
                      setEdittedRow({
                        ...edittedRow,
                        ssl: item.label,
                        ssl_id: item.value,
                      })
                    }
                    options={options[1].options || []}
                    dropdown={true}
                    height={'35px'}
                    mini={true}
                  />
                ))
              ),
              license: (
                <LicenseInput
                  initialValue={edittedRow?.license}
                  onBlurSave={(e) => {
                    setEdittedRow({ ...edittedRow, license: e });
                  }}
                  inputHeight={'25px'}
                />
              ),
            },
          ]}
          totalCount={0}
          keyField="id"
          getRowStyle={() => ({
            width: 'webkit-fill-available',
            height: '50px',
            fontSize: '11px',
            borderTop: 'none',
            borderRadius: '0px',
            paddingBottom: '2px',
            overflow: 'hidden',
          })}
          noGap={true}
          // scrollLeft={scrollLeft}
          // topScroll={ctRef?.current?.scrollHeight}
          mini={true}
          scroll={true}
          max-height={'220px'}
          width={'-webkit-fill-available'}
        />
      </div>
      <div className={styles.buttonContainer}>
        <SubmitButton
          text={'Save Changes'}
          onClick={handleSubmit}
          loading={loadingSubmit}
          disable={!edittedRow.specification_id && !edittedRow.ssl_id}
        />
      </div>
    </div>
  );
};

const EditContainerModal = ({
  show,
  setShow,
  onSave,
  containerData,
  options,
  loadingSubmit,
  handleSubmit,
  edittedRow,
  setEdittedRow,
}) => {
  return (
    <Modal
      minWidth={'unset'}
      show={show}
      setShow={setShow}
      icon={'editIcon'}
      title={'Edit Container'}
      submit={onSave}
      notClose={true}
      children={
        <EditContainerModalContent
          containerData={containerData}
          options={options}
          loadingSubmit={loadingSubmit}
          handleSubmit={handleSubmit}
          edittedRow={edittedRow}
          setEdittedRow={setEdittedRow}
        />
      }
    />
  );
};

export default EditContainerModal;
